export default __webpack_public_path__ + "target-trackc702b0.svg";